import ApiService from './ApiService';
import * as queryString from 'query-string';

export default class IconsService {
  static async findAll(query = {}, config = {}) {
    return await ApiService.get(`icon-shapes?${queryString.stringify(query)}`, config);
  }

  static async findCategories() {
    return await ApiService.get(`icon-shapes/category`);
  }

  static async findOne(id) {
    return await ApiService.get(`icon-shapes/${id}`);
  }

  static async findOneIconById(id) {
    return await ApiService.get(`icons/${id}`);
  }

  static async findOneIconDescriptionById(id) {
    return await ApiService.get(`icons/description/${id}`);
  }

  static async findOneTagByName(name) {
    return await ApiService.get(`icons/tag/${name}`);
  }
}
